@if (team) {
  <div class="pagewrapper">
    @if (canManagePlanAndFunding && !this.team.role && team.plan === freePlan) {
      <div class="teaser">
        <img class="teaserimage" src="assets/graphics/getting_started.png" />
        <div class="teaserright">
          <span
            >Want even more <span class="bold">choice</span> and
            <span class="bold">control?</span></span
            >
            <span class="link" (click)="changePlan()">Upgrade to the Plus plan</span>
          </div>
        </div>
      }
      <div class="editsection">
        <span><span class="listitem">1. Wellspace: </span>{{ ' ' + team.name }}</span>
        <button mat-button shape="" class="editbutton" (click)="editName()">Edit</button>
      </div>
      <div class="editsection">
        <div class="center-toggle-content">
          <mat-slide-toggle
            #reimbursementsToggle
            [checked]="!team?.disabled"
            (change)="enabledChanged($event)"
            >
            Allow reimbursements
          </mat-slide-toggle>
          @if (showReimbursementsSpinner) {
            <mat-spinner
              class="team-edit-toggle-spinner"
              [color]="'accent'"
              [diameter]="20"
            ></mat-spinner>
          }
        </div>
      </div>
      <div class="editsection">
        <div class="center-toggle-content">
          <mat-slide-toggle
            #monthlyAllowanceToggle
            [checked]="!team?.topupDisabled"
            (change)="topupEnabledChanged($event)"
            >
            Enable monthly allowance
          </mat-slide-toggle>
          @if (showMonthlyAllowanceSpinner) {
            <mat-spinner
              class="team-edit-toggle-spinner"
              [color]="'accent'"
              [diameter]="20"
            ></mat-spinner>
          }
        </div>
      </div>
      <div class="editsection">
        <span><span class="listitem">2. Benefits:</span></span>
        <button mat-button shape="" class="editbutton" (click)="editCategories()">Edit</button>
      </div>
      <span class="editsection">Reimbursement Categories: {{ team.categories.length }}</span>
      <div class="categories">
        <mat-chip-set>
          @for (category of categories; track category) {
            <mat-chip>
              <div class="chipinfo">
                <span>{{ category.category }}</span>
                @if (category.taxable) {
                  <span class="taxable">Taxable</span>
                }
              </div>
            </mat-chip>
          }
        </mat-chip-set>
      </div>
      <div class="excluded-transactions">
        <mat-form-field appearance="outline" class="excluded-transactions-field">
          <mat-label>Excluded transactions</mat-label>
          <mat-chip-grid #excludedTransactionChipGrid aria-label="Excluded transactions">
            @for (term of excludedTransactionTerms; track trackExcludedTransactionTerm($index, term)) {
              <mat-chip-row
                [removable]="!isExcludedTransactionsSaving"
                (removed)="removeExcludedTransactionTerm(term)"
                >
                {{ term }}
                <button
                  matChipRemove
                  type="button"
                  [disabled]="isExcludedTransactionsSaving"
                  [attr.aria-label]="'Remove ' + term"
                  >
                  <mat-icon>cancel</mat-icon>
                </button>
              </mat-chip-row>
            }
            <input
              placeholder="amazon prime"
              [disabled]="isExcludedTransactionsSaving"
              [matChipInputFor]="excludedTransactionChipGrid"
              [matChipInputSeparatorKeyCodes]="excludedTransactionSeparatorKeysCodes"
              [matChipInputAddOnBlur]="true"
              (matChipInputTokenEnd)="addExcludedTransactionTerm($event)"
              matInput
              />
          </mat-chip-grid>
        </mat-form-field>
        <div class="excluded-transactions-helper">
          Transactions whose description contains one of these phrases will not be reimbursed for this team.
        </div>
        @if (broadExcludedTransactionTerms.length) {
          <div class="excluded-transactions-warning">
            <mat-icon>warning_amber</mat-icon>
            <span>
              Broad exclusions such as {{ broadExcludedTransactionTerms.join(', ') }} can hide unrelated eligible transactions.
            </span>
          </div>
        }
      </div>
      <div class="excluded-transactions">
        <mat-form-field appearance="outline" class="excluded-transactions-field">
          <mat-label>Included transactions</mat-label>
          <mat-chip-grid #includedTransactionChipGrid aria-label="Included transactions">
            @for (term of includedTransactionTerms; track trackIncludedTransactionTerm($index, term)) {
              <mat-chip-row
                [removable]="!isIncludedTransactionsSaving"
                (removed)="removeIncludedTransactionTerm(term)"
                >
                {{ term }}
                <button
                  matChipRemove
                  type="button"
                  [disabled]="isIncludedTransactionsSaving"
                  [attr.aria-label]="'Remove ' + term"
                  >
                  <mat-icon>cancel</mat-icon>
                </button>
              </mat-chip-row>
            }
            <input
              placeholder="uber"
              [disabled]="isIncludedTransactionsSaving"
              [matChipInputFor]="includedTransactionChipGrid"
              [matChipInputSeparatorKeyCodes]="includedTransactionSeparatorKeysCodes"
              [matChipInputAddOnBlur]="true"
              (matChipInputTokenEnd)="addIncludedTransactionTerm($event)"
              matInput
              />
          </mat-chip-grid>
        </mat-form-field>
        <div class="excluded-transactions-helper">
          Transactions whose description contains one of these phrases will be considered reimbursable for this team.
        </div>
      </div>
      @if (team?.approved) {
        <app-monthly-topup-schedule [teamId]="team.id" [settingsVersion]="team.amount + ':' + team.topupDisabled + ':' + team.defaultPaymentMethod"></app-monthly-topup-schedule>
      }
      <span class="editsection">Monthly allowance amount: ${{ team.amount.toFixed(2) }}</span>
      @if (!this.team.role) {
        <div class="paymentsection">
          <span class="editsection">Plan: {{ this.team.plan }}</span>
          @if (canManagePlanAndFunding) {
            <span class="linkbutton" (click)="changePlan()">Change Plan</span>
          }
        </div>
      }
      @if (this.team.role) {
        <div class="paymentsection">
          @if (!paymentMethod) {
            <span class="editsection">Funding Method:</span>
          }
          <span class="linkbutton"
            >You are a delegated admin so you can't change the funding method. Only team owners can change
            the funding method.</span
            >
          </div>
        }
        @if (!this.team.role && !paymentMethod) {
          <div class="paymentsection">
            <span class="editsection">Funding Method: None</span>
            @if (canManagePlanAndFunding) {
              <span class="linkbutton" (click)="addPaymentMethod()">Add funding method</span>
            }
          </div>
        }
        @if (!this.team.role && paymentMethod) {
          <div class="paymentsection">
            <span class="editsection"
              >Default Funding Method: {{ paymentMethod.bankInfo.bankName }} ****{{
              paymentMethod.stripeLast4
              }}</span
              >
              @if (canManagePlanAndFunding) {
                <span class="linkbutton" (click)="changePaymentMethod()"
                  >Change funding method/View charge history</span
                  >
                }
              </div>
            }
            <div class="editsection">
              <span>
                <span class="listitem">3. Team Members: </span>
                @if (membersLoading) {
                  <span>Loading...</span>
                }
                @if (!membersLoading && membersLoadError) {
                  <span>Unable to load members</span>
                }
                @if (!membersLoading && !membersLoadError) {
                  <span>{{ members.length }}</span>
                }
              </span>
              <button mat-button shape="" class="editbutton" [disabled]="membersLoading || membersLoadError" (click)="editMembers()">Edit</button>
            </div>
            @if (canShowMemberFundingWarning) {
              <div
                >
                @if (newMembers.length && !this.team.role) {
                  <div class="warningbox">
                    <span>
                      You have set allowances for
                      <span style="font-weight: bold"
                        >{{ newMembers.length }} member{{ newMembers.length > 1 ? 's' : '' }} that you need to
                        fund</span
                        >
                        before they can start receiving a monthly allowance.
                      </span>
                      @if (newMembers.length && !paymentMethod && !this.team.role && canManagePlanAndFunding) {
                        <span
                          >But first, you need to
                        </span>
                      }
                      @if (newMembers.length && !paymentMethod && !this.team.role && canManagePlanAndFunding) {
                        <span
                          class="linkbutton"
                          (click)="addPaymentMethod()"
                          >add a funding method.</span
                          >
                        }
                      </div>
                    }
                    @if (
                      team.amount > 0 &&
                      newMembers.length &&
                      paymentMethod &&
                      !paymentMethod?.bankInfo?.isPending
                      ) {
                      <div
                        class="funding-member-btn-container"
                        >
                        <div class="funding-member-btn-container-inner">
                          <button
                            mat-raised-button
                            class="donebutton"
                            color="primary"
                            [disabled]="$safeNavigationMigration(monthlyTopupSchedule?.fundingBlocked)"
                            (click)="fundAllowancesClicked()"
                            >
                            Fund Member Allowances
                          </button>
                          <div class="center-toggle-content">
                            <mat-slide-toggle
                              #proRateFundingToggle
                              [checked]="team.proRate && team.proRate === 0"
                              (change)="proRateToggleChange($event)"
                              >
                              Start at next scheduled top-up
                            </mat-slide-toggle>
                          </div>
                        </div>
                        @if (showWarnCard()) {
                          <app-card
                            message="Do not forget to click on 'Fund Member Allowances' to set allowances to start on the next scheduled top-up."
                            type="warning"
                          ></app-card>
                        }
                      </div>
                    }
                  </div>
                }
                @if (team.amount === 0 && !paymentMethod?.bankInfo?.isPending) {
                  <div class="warningbox">
                    <span
                      >You have not yet set an allowance amount or benefits categories so you will only be able to
                      send instant one-time rewards to team members.</span
                      >
                    </div>
                  }
                  @if (paymentMethod?.bankInfo?.isPending) {
                    <div class="warningbox">
                      <span
                        >The current payment method status is 'Pending'. To proceed, please select a verified payment
                        method.</span
                        >
                      </div>
                    }
                    <div class="list">
                      <div class="invite-button">
                        <app-send-invites-button
                          [teamId]="getTeamId()"
                          [pendingInvitesCount]="pendingInvitesCount"
                          [hasPendingAutomation]="hasPendingInviteAutomation"
                          (invitesSent)="loadTeamMembers()"
                        ></app-send-invites-button>
                      </div>
                      @for (member of members; track member) {
                        <div class="card">
                          <app-user-item
                            (memberChangedEvent)="loadTeamMembers()"
                            class="useritem"
                            [showHeader]="member === members[0]"
                            [team]="team"
                            [wallitBalance]="isAdmin"
                            [member]="member"
                            [detail]="true"
                          ></app-user-item>
                        </div>
                      }
                      @if (members && members.length === 0) {
                        <span class="nomembers">No team members</span>
                      }
                    </div>
                    @if (!team.approved) {
                      <span class="approvalwarning"
                        >Your team is awaiting approval by Wallit.</span
                        >
                      }
                      <span class="questions">Have questions about your wellspace?</span>
                      <span class="questions"
                        >Drop us a note at <a class="link" href="mailto:help@wallit.app">help&#64;wallit.app</a></span
                        >
                        <div class="buttons">
                          @if (team.amount === 0 && newMembers.length && paymentMethod) {
                            <button
                              mat-raised-button
                              class="donebutton"
                              color="primary"
                              (click)="sendEmailsClicked()"
                              >
                              Invite Team Members
                            </button>
                          }
                          @if (team && canSendOneTimeRewards()) {
                            <button
                              [disabled]="!team.approved"
                              mat-raised-button
                              class="donebutton"
                              color="primary"
                              (click)="sendOnetimeClicked()"
                              >
                              One Time Reward
                            </button>
                          }
                          @if (team && paymentMethod && !paymentMethod?.bankInfo?.isPending) {
                            <button
                              [disabled]="!team.approved"
                              mat-raised-button
                              class="donebutton"
                              color="primary"
                              (click)="uploadRewardsClicked()"
                              >
                              Upload Rewards
                            </button>
                          }
                          @if (team && paymentMethod && !paymentMethod?.bankInfo?.isPending) {
                            <button
                              [disabled]="!team.approved"
                              mat-raised-button
                              class="donebutton"
                              color="primary"
                              (click)="sendOnetimeP2pClicked()"
                              >
                              Member-to-Member Top Up
                            </button>
                          }
                          @if (team) {
                            <button
                              mat-raised-button
                              class="donebutton"
                              color="warn"
                              (click)="deleteClicked()"
                              >
                              Delete Wellspace
                            </button>
                          }
                        </div>
                      </div>
                    }
